var m = require('mithril');

module.exports = {
  view: (vnode) => {
    return m('div.mr1.w-100.mb2', vnode.attrs, vnode.children);
  }
}